import type { ExtractedDocxRevision } from "@nevisign/reader-core";
import type { ReaderComment } from "../lib/annotationStore";

type Props = {
  comments: ReaderComment[];
  revisions: ExtractedDocxRevision[];
  activeId: string | null;
  onSelect: (id: string) => void;
};

function formatDate(iso?: string): string {
  if (!iso) return "";
  try {
    return new Intl.DateTimeFormat("fa-IR", {
      dateStyle: "medium",
      timeStyle: "short",
    }).format(new Date(iso));
  } catch {
    return iso;
  }
}

export function CommentsSidebar({
  comments,
  revisions,
  activeId,
  onSelect,
}: Props) {
  const visible = comments.filter((c) => !c.deleted);

  return (
    <div>
      {visible.length === 0 && (
        <p className="settings-hint">یادداشتی در این سند نیست.</p>
      )}
      {visible.map((c) => (
        <button
          key={c.word_id}
          type="button"
          className={`comment-card${activeId === c.word_id ? " active" : ""}${
            c.resolved ? " resolved" : ""
          }`}
          onClick={() => onSelect(c.word_id)}
        >
          <div className="comment-meta">
            <span>{c.author}</span>
            <span>{formatDate(c.date)}</span>
          </div>
          {c.quote && <div className="comment-quote">{c.quote}</div>}
          <div className="comment-body">{c.body || "—"}</div>
          {c.resolved && <span className="resolved-badge">برطرف شده</span>}
          {(c.replies?.length ?? 0) > 0 && (
            <div className="comment-meta" style={{ marginTop: "0.35rem" }}>
              {c.replies!.length} پاسخ
            </div>
          )}
        </button>
      ))}

      {revisions.length > 0 && (
        <>
          <h3 style={{ fontSize: "0.85rem", margin: "1rem 0 0.5rem" }}>
            تغییرات ردیابی‌شده
          </h3>
          {revisions.slice(0, 40).map((r) => (
            <div key={`${r.type}-${r.word_id}`} className="comment-card">
              <div className="comment-meta">
                <span>
                  <span className={`rev-chip ${r.type}`}>
                    {r.type === "ins" ? "درج" : "حذف"}
                  </span>{" "}
                  {r.author}
                </span>
                <span>{formatDate(r.date)}</span>
              </div>
              <div className="comment-body">{r.text}</div>
            </div>
          ))}
        </>
      )}
    </div>
  );
}
